import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'tmt-ui-kit';
import { connect } from 'react-redux';

import withTrip from '../withTrip';
import { actions as availabilityActions } from '~/redux/reducers/availability';
import { actions as sessionActions } from '~/redux/reducers/session';

const enhance = connect(
  state => {
    const selectedDate = state.availability.selectedDate.length > 0 ? state.availability.selectedDate : state.session.data.selectedDate;
    return {
      selectedDate,
      availability: state.availability,
      sessionData: state.session.data,
      loading: (state.trip.loading || state.session.isLoadingSessionData || !state.session.isSessionDataLoaded),
    };
  }, {
    toggleAcceptSwap: availabilityActions.toggleAcceptSwap,
    setSessionData: sessionActions.setSessionData,
  }
);

const TripQuantitySelector = (props) => {
  const [prevLoading, setPrevLoading] = useState(true);

  useEffect(() => {
    if (prevLoading && !props.loading) {
      const { trip, sessionData } = props;
      let { quantity, childQuantity = 0 } = sessionData;
      const isChildEnabled = trip.additional_options && !!trip.additional_options.find(option => option.type === 'child_price');
      if (!isChildEnabled) {
        childQuantity = 0;
        quantity = trip.max_travelers < quantity ? trip.max_travelers : quantity;
      } if (trip.max_travelers < quantity + childQuantity) {
        if (trip.max_travelers < quantity) {
          quantity = trip.max_travelers;
          childQuantity = 0;
        } else {
          childQuantity = trip.max_travelers - quantity;
        }
      }
      props.setSessionData({ quantity, childQuantity }, true);
      setPrevLoading(props.loading);
    }
  }, [prevLoading === props.loading]);

  const onChangeChildQuantity = async (childQuantity) => {
    const { onChangeCustomize, trip, sessionData } = props;
    const { quantity } = sessionData;
    if (onChangeCustomize) {
      onChangeCustomize(quantity + childQuantity > trip.max_travelers);
    }
    await props.setSessionData({ ...sessionData, childQuantity }, true);
  };

  const onChangeQuantity = async (quantity) => {
    const { onChangeCustomize, trip, sessionData } = props;
    const { childQuantity } = sessionData;
    if (onChangeCustomize) {
      onChangeCustomize(quantity + childQuantity > trip.max_travelers);
    }
    await props.setSessionData({ ...sessionData, quantity }, true);
  };

  const { trip, sessionData } = props;
  const { quantity, childQuantity } = sessionData;
  const isChildEnabled = trip.additional_options && !!trip.additional_options.find(option => option.type === 'child_price');
  let childSubLabel = '';
  if (isChildEnabled) {
    const childTitle = isChildEnabled ? trip.additional_options.find(option => option.type === 'child_price').title : '';
    const textInsideParentheses = /\(([^)]*)\)/.exec(childTitle);
    childSubLabel = textInsideParentheses ? textInsideParentheses[1] : '';
  }

  return (
    <div>
      <Form.QuantityInput
        label={isChildEnabled ? 'Adults' : 'Guest(s)'}
        max={999999}
        min={1}
        onChangeCounter={onChangeQuantity}
        value={quantity}
      />
      {isChildEnabled && (
        <Form.QuantityInput
          label="Children"
          max={999999}
          min={0}
          onChangeCounter={onChangeChildQuantity}
          subLabel={childSubLabel}
          value={childQuantity}
        />
      )}
    </div>
  );
};

TripQuantitySelector.propTypes = {
  trip: PropTypes.object,
  sessionData: PropTypes.object,
  onChangeCustomize: PropTypes.func,
  setSessionData: PropTypes.func,
  loading: PropTypes.bool,
};

export default withTrip(enhance(TripQuantitySelector));
